<template>
  <list-content>
    <v-col cols="12">
      <error-component v-if="mustHandleError" :error="error" transparent-background />
      <order-documents-loading v-else-if="loading.documents" />
      <list-empty
        v-else-if="documents.length === 0"
        :icon="mdiFileDocumentOutline"
        :message="$t('noOrderDocumentsFound')"
      />
      <v-row v-else-if="documents.length > 0" density="comfortable" justify="center">
        <v-col>
          <v-row density="comfortable" class="flex-row-reverse">
            <v-col cols="auto">
              <v-btn
                ref="downloadAll"
                :loading="loading.downloadAllDocuments"
                :icon="$vuetify.display.smAndDown"
                variant="text"
                class="mr-2"
                color="primary"
                :aria-label="$t('downloadAllOrderDocumentsAsPdf')"
                @click="downloadAllDocuments"
              >
                <v-icon :icon="mdiDownload" />
                <span class="d-none d-md-block">{{ $t('PDF') }}</span>
              </v-btn>
            </v-col>
          </v-row>
          <v-row density="comfortable">
            <v-col cols="12">
              <order-document-row
                v-for="document in documents"
                :key="document.id"
                :order-document="document"
                :order-id="orderId"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </list-content>
</template>

<script setup lang="ts">
import ListContent from '@/components/list/ListContent.vue'
import ListEmpty from '@/components/list/ListEmpty.vue'
import ErrorComponent from '@/modules/error/components/ErrorComponent.vue'
import { customErrorHandling } from '@/modules/error/helpers'
import OrderDocumentRow from '@/modules/order/components/OrderDocumentRow.vue'
import OrderDocumentsLoading from '@/modules/order/components/OrderDocumentsLoading.vue'
import useOrderDocuments from '@/modules/order/useOrderDocuments'
import OrderEvent from '@/modules/tracking/events/order'
import { trackEvent } from '@/modules/tracking/useTracking'
import { mdiDownload, mdiFileDocumentOutline } from '@mdi/js'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

defineOptions({ name: 'OrderDocuments' })

const props = defineProps({
  orderIdProp: {
    type: String,
    default: undefined
  }
})

const { error, mustHandleError } = customErrorHandling()
const { documents, loading } = storeToRefs(useOrderDocuments())
const currentRoute = useRoute()
const orderId = ref(props.orderIdProp ? props.orderIdProp : (currentRoute.params.id as string))

useOrderDocuments().getOrderTransactions(orderId.value)

const downloadAllDocuments = () => {
  useOrderDocuments().loadAllPDFDocuments(orderId.value)
  trackEvent(OrderEvent.Download.All)
}
</script>
